import { Suspense, lazy, useMemo } from "react";
import { useParams, Navigate } from "react-router-dom";
import { getCaseStudy } from "@/data/caseStudies";
import CaseStudyLayout from "@/components/CaseStudyLayout";

/**
 * Route: /case-studies/:slug
 *
 * Mirrors the Article.jsx code-split pattern. Every new case study
 * gets one line in BODIES + one entry in `data/caseStudies.js`.
 */
const BODIES = {
  "jaipur-atelier-jadau-rani-haar": lazy(() =>
    import("./caseStudies/JaipurAtelierRaniHaar.jsx"),
  ),
};

export default function CaseStudy() {
  const { slug } = useParams();
  const meta = useMemo(() => getCaseStudy(slug), [slug]);

  if (!meta || !BODIES[slug]) return <Navigate to="/case-studies" replace />;

  const Body = BODIES[slug];

  return (
    <CaseStudyLayout meta={meta}>
      <Suspense fallback={<p className="text-white/40 text-sm">Loading case study…</p>}>
        <Body />
      </Suspense>
    </CaseStudyLayout>
  );
}
